import React, { useState, useEffect } from 'react'
import { Icon } from 'konsys-ui'
// import Lightbox from 'react-images'
import Lightbox from 'react-image-lightbox'
import {
  DescriptionContainer, Title, ImagesContainer,
  TitleWrapper, ImageWrapper,
} from './styled'

const SampleImageList = ({
  title = 'title',
  data = [],
  onClick,
}) => {
  const [openLightBox, setOpenLightBox] = useState(false)
  const [currentImage, setCurrentImage] = useState(0)
  const [images, setImages] = useState(data ? data.sort((a, b) => a.ordering - b.ordering).map(item => (item.fileUrl)) : [])

  useEffect(() => {
    setImages(data ? data.sort((a, b) => a.ordering - b.ordering).map(item => (item.fileUrl)) : [])
  }, [data])
  return (
  <DescriptionContainer>
    <TitleWrapper>
      <Title>{title}</Title>
    </TitleWrapper>
    <ImagesContainer>
      {data && data.sort((a, b) => a.ordering - b.ordering).map((item, index) => (
        <Image
          key={index}
          img={item.fileUrl}
          onClick={() => {
            setCurrentImage(index)
            setOpenLightBox(true)
          }}
        />
      ))}
    </ImagesContainer>
    {/* <Lightbox
      images={data ? data.sort((a, b) => a.ordering - b.ordering).map(item => (
        { src: item.fileUrl }
      )) : []}
      currentImage={currentImage}
      isOpen={openLightBox}
      onClickNext={() => setCurrentImage(currentImage + 1)}
      onClickPrev={() => setCurrentImage(currentImage - 1)}
      onClose={() => setOpenLightBox(false)}
      backdropClosesModal={true}
    /> */}
    {
      openLightBox && <Lightbox
        mainSrc={images[currentImage]}
        nextSrc={images[(currentImage + 1) % images.length]}
        prevSrc={images[(currentImage + images.length - 1) % images.length]}
        onCloseRequest={() => setOpenLightBox(false)}
        onMovePrevRequest={() => setCurrentImage((currentImage + images.length - 1) % images.length)}
        onMoveNextRequest={() => setCurrentImage((currentImage + 1) % images.length)}
      />
    }
  </DescriptionContainer>)
}

const Image = ({ img, onClick }) => (
  <ImageWrapper img={img} onClick={() => onClick()}>
    <Icon icon='far fa-search-plus' />
  </ImageWrapper>
)

export default SampleImageList



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/common/sample-image-list/index.jsx